/**
 * Storage del módulo `./ThemeInit` del MFE chat-mfe. Sin dependencias de Angular
 * para que pueda ser importado desde `federation-init.ts` antes del bootstrap
 * sin arrastrar `@angular/core` al bundle eager (lo cual rompe el sharing de
 * Native Federation con el remote).
 *
 * El wrapper Angular vive en `chat-theme-bridge.service.ts`.
 */

type ChatTheme = 'light' | 'dark';

interface ChatThemeModule {
  setChatTheme?: (theme: ChatTheme) => void;
  initChatTheme?: (theme?: ChatTheme) => void;
}

let chatThemeModule: ChatThemeModule | null = null;

export function setChatThemeModule(mod: ChatThemeModule | null): void {
  chatThemeModule = mod;
}

export function applyChatTheme(isDark: boolean): void {
  const theme: ChatTheme = isDark ? 'dark' : 'light';
  chatThemeModule?.setChatTheme?.(theme);
}
